import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { useTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SearchIcon from '@material-ui/icons/Search';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';
import * as search from '_core/utils/search';
import * as api from '_core/utils/api';


const SEARCH_FIELDS = {
  'title.*': { highlight: true }
};


export const getStatusData = async () => {
  const statuses = api.getClassicVisitorStatus();
  
  const types = await api.getClassicVisitorStatusType();
  
  return (await statuses).map((status) => ({
    ...status,
    
    type: types.find((type) => type.id === status.type) || status.type
  }));
};

export const StatusValue = React.memo((props) => {
  const {
    l,
    
    classes,
    column,
    data
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  if (value === undefined || column.nameSplit.length < 2)
    return '-';
  
  const dataType = column.nameSplit[1];
  
  const dataValue = column.valueData.find((status) => status.id === value && status.type?.name === dataType);
  
  return (
    <div className={clsx(classes.statusChip, ...(dataValue?.class_list || []))}>
      <FiberManualRecordIcon />
      
      <div>{dataValue ? l(dataValue.title) : value}</div>
    </div>
  );
});

export const StatusFilter = React.memo((props) => {
  const {
    l,
    classes,
    
    filterColumn,
    
    filterValue,
    filterValueToggle,
    setFilterValue,
    
    filterApply,
    filterReset
  } = props;
  
  
  const [filterSearch, setFilterSearch] = React.useState('');
  
  
  let statusList = filterColumn.valueData;
  
  if (filterSearch)
    statusList = search.filterList(SEARCH_FIELDS, statusList, filterSearch, { className: classes.highlight });
  
  const dataType = filterColumn.nameSplit[1];
  
  return (
    <>
      <Divider />
      
      <ListItem disableGutters>
        <List className={classes.filterList} disablePadding>
          <ListItem className={classes.filterListNoPadding} disableGutters>
            <OutlinedInput
              className={classes.filterSearchInput}
              margin="none"
              placeholder={l('$backoffice.admin.portal.articles.find')}
              value={filterSearch}
              onChange={(event) => setFilterSearch(event.target.value)}
              startAdornment={(
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )}
            />
          </ListItem>
          
          <ListItem className={classes.filterStatusList} disableGutters>
            <MenuList disablePadding>
              {statusList?.slice(0, 20).map((item) => item.type?.name == dataType ? (
                <MenuItem key={item.id} onClick={() => filterValueToggle(item.id)}>
                  <ListItemText primary={(
                    <div className={classes.value}>
                      <div className={clsx(classes.statusChip, ...(item.class_list || []))}>
                        <FiberManualRecordIcon />
                        
                        <div>{l(item.title)}</div>
                      </div>
                    </div>
                  )} />
                  <ListItemSecondaryAction>
                    <Checkbox
                      edge="end"
                      onChange={() => filterValueToggle(item.id)}
                      checked={Array.isArray(filterValue) && filterValue.indexOf(item.id) >= 0}
                    />
                  </ListItemSecondaryAction>
                </MenuItem>
              ) : null).filter(Boolean)}
            </MenuList>
          </ListItem>
        </List>
      </ListItem>
      
      <Divider />
    </>
  );
});

export const StatusTags = React.memo((props) => {
  const {
    l,
    classes,
    
    filterApply,
    column,
    value
  } = props;
  
  
  const dataType = column.nameSplit[1];
  
  return value.map((item) => (
    <div className={classes.statusChip}>
      {l(column.valueData.find((status) => status.type?.name == dataType && status.id === item)?.title ?? item)}
      
      <a href="" onClick={(event) => { event.preventDefault(); filterApply(value.filter((el) => el !== item)); }}><ClearIcon /></a>
    </div>
  ));
});

export const getStatusApiParam = (column, value) => {
  return value.length ? value.join(',') : undefined;
};

export const getStatusExportValue = async (props, column, data) => {
  const {
    l
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  if (value === undefined || column.nameSplit.length < 2)
    return '-';
  
  const dataType = column.nameSplit[1];
  
  const dataValue = column.valueData.find((status) => status.id === value && status.type?.name === dataType);
  
  return dataValue ? l(dataValue.title) : value;
};
